import { render } from "./MiGrupoAgregarGrupo.vue?vue&type=template&id=f520f2ee&scoped=true"
import script from "./MiGrupoAgregarGrupo.vue?vue&type=script&lang=js"
export * from "./MiGrupoAgregarGrupo.vue?vue&type=script&lang=js"

import "./MiGrupoAgregarGrupo.vue?vue&type=style&index=0&id=f520f2ee&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f520f2ee"]])

export default __exports__